import { defaultHttpClient } from './_HttpClient';
export async function GetProductDetailPopupInfo(productID, defaultImageUrl) {
    const param = {
        productID: productID,
        defaultImageUrl: defaultImageUrl
    };
    const resp = await defaultHttpClient.post('/Ajax/ProductDetail.aspx/GetProductDetailPopupInfo', param);
    const data = resp.data;
    return JSON.parse(data.d);
}
